import { useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Alert from "./components/Alert";
import Spinner from "./components/Spinner";
import { getCookie, getLocalStorage } from "./utils/general";
import { useDispatch, useSelector } from "react-redux";
import { updateSessionExpired } from "./redux/actions/appAction";
import AppRoute from "./AppRoute";
import { verifySessionApi } from "./utils/api";
import Modal from "./components/Modal";

const tokenName = `${process.env.REACT_APP_ENVIRONMENT}qdweddingadmin`;

function App() {
  const dispatch = useDispatch();
  const appRef = useRef(null);
  const appState = useSelector((state) => state.app);

  const handleStorageChange = (event) => {
    if (
      (event.key === `${process.env.REACT_APP_ENVIRONMENT}qdweddingadmin` ||
        !event.key) &&
      !event.newValue
    ) {
      dispatch(updateSessionExpired(true));
    }
  };

  useEffect(() => {
    if (appState.sessionExpired) {
      window.location.replace("/login");
    }
  }, [appState]);

  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);

    const token = getLocalStorage(tokenName) || getCookie(tokenName);

    if (window.location.pathname === "/login") {
      if (token) window.location.replace("/");
    } else {
      if (!token) {
        window.location.replace("/login");
        return;
      }

      verifySessionApi();
    }
  }, []);

  return (
    <div className="App" ref={appRef}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="*"
          element={
            <>
              <header
                id="header"
                className="header fixed-top d-flex align-items-center"
              >
                <div className="d-flex align-items-center justify-content-between">
                  <a
                    href="index.html"
                    className="logo d-flex align-items-center"
                  >
                    <img src="/assets/img/KW-logo-icon.png" alt="" />
                    <span className="d-none d-lg-block">DQ Wedding</span>
                  </a>
                </div>
              </header>
              <main id="main" className="main">
                <AppRoute />
              </main>
              <footer id="footer" className="footer">
                <div className="copyright">
                  © Copyright{" "}
                  <strong>
                    <span>Kunway</span>
                  </strong>
                  . All Rights Reserved
                </div>
              </footer>
            </>
          }
        />
      </Routes>
      <div className="alert-message">
        <Alert />
      </div>
      <Spinner />
      <Modal />
    </div>
  );
}

export default App;
